import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-ocr-error-modal',
  templateUrl: './ocr-error-modal.component.html',
  styleUrls: ['./ocr-error-modal.component.css']
})
export class OcrErrorModalComponent implements OnInit {  
  ismobileScreen: boolean;
  @Input('data') data: any;

  constructor(private UTS: UtilitiesService,private modalController: ModalController, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.ismobileScreen = this.UTS.isMobileDevice();
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController
      .dismiss({
        dismissed: true,
      })
      .then(() => {
        this.UTS.clearError();
        this.cdr.detectChanges();
      });
  }
}
